import { apiHost } from "@libs/providers/api-host.provider";

const url = `${apiHost()}/web/projects`;

export enum HttpStatuses {
  received = 200,
  created = 201,
  notFound = 404,
  unprocessable = 422,
}

export function getProjects(skip: number, take: number, search?: string) {
  const query = new URLSearchParams({
    skip: String(skip),
    take: String(take),
  });

  if (search) {
    query.set("search", search);
  }

  return fetch(`${url}?${query}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then((response) => {
    switch (response.status) {
      case HttpStatuses.received:
        return response.json();
      case HttpStatuses.notFound:
        throw new Error("Not found");
      default:
        throw new Error("Smth bad");
    }
  });
}

export function getProjectLinks() {
  return fetch(`${url}/links`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }).then((response) => {
    switch (response.status) {
      case HttpStatuses.received:
        return response.json();
      case HttpStatuses.notFound:
        throw new Error("Not found");
      default:
        throw new Error("Smth bad");
    }
  });
}

export function getProject(link: string) {
  /** actually id is an project link */
  const projectUrl = `${apiHost()}/web/projects/${encodeURI(link)}`;
  return fetch(projectUrl).then((response) => {
    switch (response.status) {
      case HttpStatuses.received:
        return response.json();
      case HttpStatuses.notFound:
        return response.status;
      default:
        return response.status;
    }
  });
}

